<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>액션 그룹 상세</h2>

                <button class="default_btn _gray" @click="router.replace('/action/group')">그룹 목록</button>
            </div>

            <div class="group_info" v-if="state.groupInfo">
                <div>
                    <span>제목</span>
                    <div class="info">{{ state.groupInfo?.title }}</div>
                </div>
                <div>
                    <div>
                        <span>상태</span>
                        <div class="info">
                            <button v-if="state.groupInfo.state === 1" class="table_btn _blue" @click="stateChange">진행중</button>
                            <button v-else class="table_btn _gray" @click="stateChange">종료</button>
                        </div>
                    </div>
                    <div>
                        <span>등록일</span>
                        <div class="info">{{ CommonUtils.dateFormatYYMMDD(new Date(state.groupInfo.createDate)) }}</div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>활동 기간</span>
                        <div class="info">
                            {{ CommonUtils.dateFormatYYMMDD(new Date(state.groupInfo.startDate)) }} ~
                            {{ CommonUtils.dateFormatYYMMDD(new Date(state.groupInfo.endDate)) }}
                        </div>
                    </div>
                    <div>
                        <span>출석 주차</span>
                        <div class="info">
                            <input
                                type="number"
                                placeholder="주차 개수를 입력해주세요"
                                v-model="state.groupInfo.cntRound"
                                :disabled="citizen.totalLength > 0"
                            />
                            <button class="table_btn _blue" @click="saveRound" v-if="!(citizen.totalLength > 0)">저장</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="total_rank">
                <div>
                    <div class="rank_head">
                        <p>출석 현황</p>
                    </div>
                    <div class="common_table custom_scroll">
                        <table>
                            <colgroup>
                                <!-- <col style="width: 40px" /> -->
                                <col style="width: 100px" />
                                <col style="width: 40px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <!-- <th>번호</th> -->
                                    <th>이름</th>
                                    <th>참여 인원</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in state.roundList">
                                    <!-- <td>{{ idx + 1 }}</td> -->
                                    <td>{{ item.name }}</td>
                                    <td class="cnt">{{ item.cnt }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div>
                    <div class="rank_head">
                        <p>액션활동 현황</p>

                        <button class="default_btn _blue" @click="router.push(`/action/${state.groupIdx}/state`)">관리</button>
                    </div>
                    <div class="common_table custom_scroll">
                        <table>
                            <colgroup>
                                <!-- <col style="width: 40px" /> -->
                                <col style="width: 100px" />
                                <col style="width: 40px" />
                                <col style="width: 40px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <!-- <th>번호</th> -->
                                    <th>이름</th>
                                    <th>참여 인원</th>
                                    <th>상세</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in state.stateList">
                                    <!-- <td>{{ idx + 1 }}</td> -->
                                    <td>{{ item.name }}</td>
                                    <td class="cnt">{{ item.cntEntire }}</td>
                                    <td class="cnt">
                                        <button class="default_btn _blue" @click="router.push(`/action/${state.groupIdx}/state/${item.idx}`)">
                                            상세
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <template v-if="state.roundList.length > 0 && state.stateList.length > 0">
                <div class="common_table custom_scroll citizen_list">
                    <div>
                        <div class="table_head">
                            <p>종합 실적 순위</p>
                            <div>
                                <button type="button" class="default_btn _blue" @click="state.isShowCitizenModal = true">회원 등록</button>
                                <button type="button"><img src="img/excel_icon.png" alt=" 엑셀 다운로드" @click="excelDownload" /></button>
                            </div>
                        </div>
                        <div class="multi_table">
                            <table class="left_table">
                                <colgroup>
                                    <col style="width: 60px" />
                                    <col style="width: 120px" />
                                    <col style="width: auto" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>순위</th>
                                        <th>이름</th>
                                        <th>닉네임</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="citizen.list && citizen.list.length > 0">
                                        <tr v-for="(item, idx) in citizen.list">
                                            <td class="list_num cnt">{{ (citizen.currentPage - 1) * citizen.perPage + (idx + 1) }}</td>
                                            <td>{{ item.member.name }}</td>
                                            <td>{{ item.nickname }}</td>
                                        </tr>
                                    </template>
                                    <tr class="no_citizen" v-else>
                                        <td colspan="2"></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="custom_scroll">
                                <table>
                                    <colgroup>
                                        <col style="min-width: 80px" v-for="item in state.roundList" />
                                        <col style="min-width: 80px" v-for="item in state.stateList" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th v-for="item in state.roundList">{{ item.name }}</th>
                                            <th v-for="item in state.stateList">{{ item.name }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="citizen.list && citizen.list.length > 0">
                                            <tr v-for="item in citizen.list">
                                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2" v-for="round in item.roundList">
                                                    <label :for="`chk_${item.idx}_${round.brIdx}`" @click.stop>
                                                        <input
                                                            type="checkbox"
                                                            :id="`chk_${item.idx}_${round.brIdx}`"
                                                            v-model="round.isDone"
                                                            :true-value="1"
                                                            :false-value="0"
                                                            @change="changeCitizenRound(item, round)"
                                                        />
                                                        <em></em>
                                                    </label>
                                                </td>

                                                <td class="cnt" v-for="state in item.stateList">
                                                    {{ state.isDone }}
                                                </td>
                                            </tr>
                                        </template>
                                        <tr class="no_citizen" v-else>
                                            <td class="cnt" :colspan="state.roundList.length + state.stateList.length">등록된 회원이 없습니다.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <table class="right_table">
                                <colgroup>
                                    <col style="width: 50px" />
                                    <col style="width: 80px" />
                                    <col style="width: 40px" />
                                    <col style="width: 50px" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>전체 출석</th>
                                        <th>전체 액션활동 참여</th>
                                        <th>합계</th>
                                        <th>수정</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="citizen.list && citizen.list.length > 0">
                                        <tr v-for="(item, idx) in citizen.list">
                                            <td class="cnt">{{ item.cntEntire }}</td>
                                            <td class="cnt">{{ item.cntEntireChallenge }}</td>
                                            <td class="cnt">{{ item.sum }}</td>
                                            <td class="cnt">
                                                <button class="default_btn _blue" @click="showModifyCitizen(item)">수정</button>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr class="no_citizen" v-else>
                                        <td colspan="2"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <PageBtn
                        v-if="citizen.list.length !== 0"
                        :currentPage="citizen.currentPage"
                        :totalLength="citizen.totalLength"
                        :perPage="citizen.perPage"
                        @onPaging="handlePageCitizen"
                    ></PageBtn>
                </div>
            </template>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="modal.tab"
        :title="modal.title"
        :content="modal.content"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>

    <ActionCitizenModal
        v-if="state.isShowCitizenModal"
        :idx="state.groupIdx"
        @close="closeCitizenModal"
        @change="getCitizenList"
    ></ActionCitizenModal>
    <ActionCitizenAddModal
        v-if="state.isShowNicknameModal"
        :data="citizen.selectCitizen"
        :isEdit="true"
        @close="state.isShowNicknameModal = false"
        @callback="modifyCitizen"
    ></ActionCitizenAddModal>
</template>
<script lang="ts" config>
    import {
        Header,
        Left,
        ModalDefault,
        AdminManageModal,
        PageBtn,
        CommonUtils,
        router,
        reactive,
        onMounted,
        useRoute,
        apiService,
        getMessageByCode,
        types,
        ActionCitizenModal,
        ActionCitizenAddModal,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, AdminManageModal: AdminManageModal, ActionCitizenModal, ActionCitizenAddModal },
        setup() {
            const route = useRoute();
            const state = reactive({
                isShowModal: false as boolean,
                isShowCitizenModal: false as boolean,
                isShowNicknameModal: false as boolean,

                groupIdx: 0 as number,
                groupInfo: {} as types.ResActionGroupDetailForApi,
                roundList: [] as types.ResRoundForGroup[],
                stateList: [] as types.ResStateForGroup[],
            });

            const citizen = reactive({
                selectCitizen: {} as types.ResCitizenDetail,
                list: [] as types.ResCitizenDetail[],

                currentPage: 1 as number,
                perPage: 5 as number,
                totalLength: 0 as number,
            });

            const modal = reactive({
                tab: 0 as number,
                title: "" as string,
                content: "" as string,
            });

            onMounted(() => {
                if (route.params.idx && Number(route.params.idx)) {
                    state.groupIdx = Number(route.params.idx);
                    getDetail();
                }
            });

            const getDetail = async () => {
                const res = await apiService.actionGroup.detail(state.groupIdx);
                if (res.returnCode === 0) {
                    state.groupInfo = res.data;
                    state.roundList = res.roundList;
                    state.stateList = res.stateList;

                    if (state.roundList.length > 0 && state.stateList.length > 0) {
                        getCitizenList();
                    }
                } else {
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getCitizenList = async () => {
                const param = {
                    page: citizen.currentPage,
                    size: citizen.perPage,
                    searchType: null,
                    searchText: null,
                } as types.ReqCommonPaging;
                const res = await apiService.actionCitizen.list(state.groupIdx, param);
                if (res.returnCode === 0) {
                    citizen.list = res.list.data;
                    citizen.totalLength = res.list.recordsTotal;
                } else {
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const stateChange = () => {
                if (state.groupInfo.state === 1) {
                    modal.tab = 5;
                    modal.title = "알림";
                    modal.content = "액션 시민 그룹을 종료 하시겠습니까?";
                    state.isShowModal = true;
                } else toggleState();
            };

            const toggleState = async () => {
                const res = await apiService.actionGroup.change(state.groupInfo.idx);
                if (res.returnCode === 0) {
                    getDetail();
                } else {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                }
            };

            const callBackModal = (param: any) => {
                if (param.action === "confirm") {
                    toggleState();
                }
                state.isShowModal = false;
            };

            const handlePageCitizen = (page: number) => {
                citizen.currentPage = page;
                getCitizenList();
            };

            const saveRound = async () => {
                const param = {
                    cntRound: state.groupInfo.cntRound,
                    title: "",
                    startDate: "",
                    endDate: "",
                } as types.ReqActionGroup;
                const res = await apiService.actionGroup.modify(state.groupIdx, param);
                if (res.returnCode === 0) {
                    getDetail();
                } else {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                }
            };

            const showModifyCitizen = (item: types.ResCitizenDetail) => {
                state.isShowNicknameModal = true;
                citizen.selectCitizen = item;
            };

            const modifyCitizen = async (info: { nickname: string }) => {
                const param = { nickname: info.nickname };
                const res = await apiService.actionCitizen.modify(state.groupIdx, citizen.selectCitizen.idx, param);
                if (res.returnCode === 0) {
                    state.isShowNicknameModal = false;
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "수정이 완료되었습니다.";
                    getCitizenList();
                } else {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                }
            };

            const closeCitizenModal = () => {
                state.isShowCitizenModal = false;
                getCitizenList();
            };

            const excelDownload = async () => {
                try {
                    const param: types.ReqUserForExcel = {
                        searchType: null,
                        searchText: null,
                        idxList: "",
                    };

                    const res = await apiService.actionCitizen.excelDownload(state.groupIdx, param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        modal.tab = -1;
                        modal.title = "알림";
                        modal.content = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const changeCitizenRound = async (item: types.ResCitizenDetail, round: types.ResRoundForCitizen) => {
                const param = { value: round.isDone };
                const res = await apiService.actionCitizen.modifyRound(state.groupIdx, round.brIdx, item.idx, param);
                if (res.returnCode === 0) {
                    getDetail();
                } else {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                }
            };

            return {
                state,
                citizen,
                modal,
                CommonUtils,
                router,
                getCitizenList,
                stateChange,
                callBackModal,
                handlePageCitizen,
                saveRound,
                closeCitizenModal,
                showModifyCitizen,
                modifyCitizen,
                excelDownload,
                changeCitizenRound,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>

<style scoped>
    .box_tit {
        margin-bottom: 10px;
    }
    .total_rank .common_table tbody tr {
        height: 30px;
    }
    .common_table.citizen_list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    :deep(.pagination) {
        margin-top: 5px;
    }
</style>
